import { classNames } from 'primereact/utils';
import {
  Control,
  Controller,
  FieldErrors,
  FieldPath,
  RegisterOptions,
} from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import React, { ReactElement } from 'react';

export interface FormInputProps<TFieldValues> {
  label: string;
  fieldName: FieldPath<TFieldValues>;
  rules?: Omit<
    RegisterOptions,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
  control: Control<TFieldValues>;
  errors: FieldErrors;
  defaultValue?: string;
}

export default function FormInput<TFieldValues>(
  props: FormInputProps<TFieldValues>,
): ReactElement {
  const { label, fieldName, rules, control, errors, defaultValue } = props;
  const getFormErrorMessage = (name: string): React.Component =>
    errors[name] && <small className="p-error">{errors[name].message}</small>;

  return (
    <div className="p-field">
      <span className="p-float-label">
        <Controller
          name={fieldName}
          control={control}
          rules={rules}
          render={({ field, fieldState }) => (
            <InputText
              {...field}
              id={field.name}
              value={String(field.value) || defaultValue || ''}
              className={`${classNames({
                'p-invalid': fieldState.error,
              })} ${field.value ? 'border-teal-300' : null}`}
              readOnly={!!defaultValue}
            />
          )}
        />
        <label
          htmlFor={fieldName}
          className={classNames({ 'p-error': errors.name })}
        >
          {label}{' '}
          {rules?.required ? (
            <span
              style={{
                fontWeight: 'bold',
                fontSize: '1.3rem',
                color: '#14a8a6',
              }}
            >
              *
            </span>
          ) : null}
        </label>
      </span>
      {getFormErrorMessage(fieldName)}
    </div>
  );
}
